import { styled } from 'linaria/react';

export const GreyBlock = styled.div`
  position: relative;
  left: calc(-50vw + 50%);
  width: 100vw !important;
  padding: var(--space-500) 0;
  background-color: var(--background-secondary);
  &:before,
  &:after {
    position: absolute;
    left: 0;
    width: 100vw;
    height: 40px;
    background: linear-gradient(180deg, rgba(70, 76, 92, 0.04) 0%, rgba(255, 255, 255, 0) 100%);
    content: '';
  }
  &:before {
    top: 0;
  }
  &:after {
    bottom: 0;
    transform: scale(-1);
  }
`;
